import { createContext, Dispatch, SetStateAction, useState } from "react";

type TUserInfoContext = {
  fullname: string;
  setFullname: Dispatch<SetStateAction<string>>;
  userId: string;
  setUserId: Dispatch<SetStateAction<string>>;
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
  password: string;
  setPassword: Dispatch<SetStateAction<string>>;
  score: number;
  setScore: Dispatch<SetStateAction<number>>;
  scoresDetail: any;
  setScoresDetail: Dispatch<SetStateAction<any>>;
  problemScoreDetail: string;
  setProblemScoreDetail: Dispatch<SetStateAction<string>>;
  ip: string;
  setIp: Dispatch<SetStateAction<string>>;
  isLogged: boolean;
  setIsLogged: Dispatch<SetStateAction<boolean>>;
};

export const UserInfoContext = createContext<TUserInfoContext>({
  fullname: "",
  setFullname: () => {},
  userId: "",
  setUserId: () => {},
  email: "",
  setEmail: () => {},
  password: "",
  setPassword: () => {},
  score: 0,
  setScore: () => {},
  scoresDetail: {},
  setScoresDetail: () => {},
  problemScoreDetail: "",
  setProblemScoreDetail: () => {},
  ip: "0.0.0.0",
  setIp: () => {},
  isLogged: false,
  setIsLogged: () => {},
});

export const UserInfoProvider = ({ ...props }) => {
  const { children } = props;
  const [fullname, setFullname] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [score, setScore] = useState<number>(0);
  const [scoresDetail, setScoresDetail] = useState<Object>({});
  const [problemScoreDetail, setProblemScoreDetail] = useState<string>("");
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [ip, setIp] = useState<string>("0.0.0.0");

  return (
    <UserInfoContext.Provider
      value={{
        fullname,
        userId,
        email,
        password,
        score,
        scoresDetail,
        problemScoreDetail,
        ip,
        isLogged,
        setFullname,
        setUserId,
        setEmail,
        setPassword,
        setScore,
        setScoresDetail,
        setProblemScoreDetail,
        setIp,
        setIsLogged,
      }}
    >
      {children}
    </UserInfoContext.Provider>
  );
};
